export default __webpack_public_path__ + "static/media/warning_dot.dc260c72.svg";